/* hs-eslint ignored failing-rules */

'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import { DELETE_ASSET_SCHEDULE } from 'dashboard-lib/public/emails/emails';
import { useMutation } from 'data-fetching-client';
import { ReportActionsFloatingAlertStore } from 'reporting-action-components/shared/ReportActionsFloatingAlertStore';
import { useTracker } from '../../../utils/hooks/useTracker';
import { EVENTS } from '../../../utils/usageTracker';
import { getDialogText } from '../../shareAsset/shareAssetAlertMessages';
import { noop } from '../../shared/noop';
import { jsx as _jsx } from "react/jsx-runtime";
const assetSpecificTrackingPropsPropDefault = {};
const DeleteEmailConfirmModal = ({
  appUsageTracker,
  closeDialog,
  scheduleId,
  onEditSuccess = noop,
  objectType,
  assetSpecificTrackingProps = assetSpecificTrackingPropsPropDefault,
  currentDialog
}) => {
  const usageTracker = useTracker(appUsageTracker);
  const [deleteAssetMutation] = useMutation(DELETE_ASSET_SCHEDULE);
  const dialog = getDialogText(currentDialog);
  const handleDelete = () => {
    if (usageTracker) {
      usageTracker.track(EVENTS.updateSavedRecurringShareAsset, Object.assign({
        object: 'email',
        actionType: 'save',
        action: 'delete',
        interactionSource: 'dialog',
        assetType: objectType.toLowerCase()
      }, assetSpecificTrackingProps));
    }
    deleteAssetMutation({
      variables: {
        scheduleId
      }
    }).then(() => {
      ReportActionsFloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.deleteAction.alert.success",
          options: {
            dialog
          }
        }),
        type: 'success',
        'data-test-id': 'recurring-email-delete-success-alert'
      });
      onEditSuccess();
    }, () => {
      ReportActionsFloatingAlertStore.addAlert({
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.deleteAction.alert.error.title",
          options: {
            dialog
          }
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.deleteAction.alert.error.description"
        }),
        type: 'danger'
      });
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  };
  return /*#__PURE__*/_jsx(UIConfirmModal, {
    confirmUse: "danger",
    message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.deleteAction.dialog.message",
      options: {
        dialog
      }
    }),
    description: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.deleteAction.dialog.description",
      options: {
        dialog
      }
    }),
    confirmLabel: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.deleteAction.dialog.confirm",
      options: {
        dialog
      }
    }),
    onConfirm: () => {
      handleDelete();
      closeDialog();
    },
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.deleteAction.dialog.reject"
    }),
    onReject: closeDialog,
    use: "danger",
    "data-test-id": "recurring-email-delete-confirm-modal"
  });
};
DeleteEmailConfirmModal.propTypes = {
  appUsageTracker: PropTypes.object.isRequired,
  closeDialog: PropTypes.func.isRequired,
  scheduleId: PropTypes.number.isRequired,
  onEditSuccess: PropTypes.func,
  objectType: PropTypes.string.isRequired,
  assetSpecificTrackingProps: PropTypes.object,
  currentDialog: PropTypes.string
};
export default DeleteEmailConfirmModal;